






























































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { tickets } from '@/modules/shared/shared/store/namespaces';
import { ContactTypes } from '@/modules/shared/shared/domain/constants/constants';

@Component
export default class PDTFolks extends Vue {
    client = {
        name: 'Pedro',
        surname: 'Pérez',
        companyName: 'Empresa super importante',
        ci: 'V12345678',
        phone: '(212) 169.38.68',
    };
    people = [
        {
            name: 'Pedro',
            surname: 'Pérez',
            companyName: 'Empresa super importante',
            ci: 'V12345678',
            phone: '(212) 169.38.68',
            type: 'solicitante',
        },
        {
            name: 'Pedro',
            surname: 'Pérez',
            companyName: 'Empresa super importante',
            ci: 'V12345678',
            phone: '(212) 169.38.68',
            type: 'responsable',
        },
        {
            name: 'Pedro',
            surname: 'Pérez',
            companyName: 'Empresa super importante',
            ci: 'V12345678',
            phone: '(212) 169.38.68',
            type: 'autorizada',
        },
        {
            name: 'Pedro',
            surname: 'Pérez',
            companyName: 'Empresa super importante',
            ci: 'V12345678',
            phone: '(212) 169.38.68',
            type: 'adicional',
        },
        {
            name: 'Pedro',
            surname: 'Pérez',
            companyName: 'Empresa super importante',
            ci: 'V12345678',
            phone: '(212) 169.38.68',
            type: 'autorizada',
        },
        {
            name: 'Pedro',
            surname: 'Pérez',
            companyName: 'Empresa super importante',
            ci: 'V12345678',
            phone: '(212) 169.38.68',
            type: 'adicional',
        },
    ];

    getColor(type: number): string {
        switch (type) {
            case ContactTypes.APPLICANT.id:
                return '#60BB46';
            case ContactTypes.RESPONSIBLE.id:
                return '#00AAB8';
            case ContactTypes.AUTHORIZED.id:
                return '#F9A31B';
        }
        return 'black';
    }

    getContactTypes(accessContactId: number) {
        let contactTypes: string = '';

        const contactDetails = this.ticketDetail.accessPermission.accessContacts.find(
            element => element.id === accessContactId,
        ).contactDetails;

        contactDetails.forEach((i, k) => {
            contactTypes += `${i.contactType.name}`;

            if (k + 1 < contactDetails.length) {
                contactTypes += ' - ';
            }
        });

        return contactTypes;
    }

    @tickets.State('ticketDetail') ticketDetail;
}
